import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/_core/shared.module';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { VouchersComponent } from './vouchers/vouchers.component';
import { MainComponent } from './main/main.component';
import { SearchComponent } from './search/search.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { VoucherComponent } from './voucher/voucher.component';
import { PwaPromptEventsComponent } from 'src/app/components/pwa-prompt-events/pwa-prompt-events.component';
import { BuyVoucherComponent } from './buy-voucher/buy-voucher.component';


@NgModule({
  declarations: [
    HomeComponent,
    VouchersComponent,
    MainComponent,
    SearchComponent,
    FavoritesComponent,
    VoucherComponent,
    PwaPromptEventsComponent,
    BuyVoucherComponent
  ],
  imports: [
    SharedModule,
    HomeRoutingModule
  ]
})
export class HomeModule { }
